import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
  selector: 'app-pre-paid-modal',
  templateUrl: './pre-paid-modal.component.html',
  styleUrls: ['./pre-paid-modal.component.css'],
})
export class PrePaidModalComponent implements OnInit {
  prePaidForm = this.fb.group({
    providerName: [, Validators.required],
    energyRate: [, Validators.required],
    utilityName: [, Validators.required],
    tDSPRatePerMonth: [, Validators.required],
    TDSPRatePerkWh: [, Validators.required],
    FivehundredkWh: [, Validators.required],
    ThousandkWh: [, Validators.required],
    TwoThousandkWh: [, Validators.required],
    tDU_Charges_Month: [, Validators.required],
    tDU_Charges_Kwh: [, Validators.required],
    link: [, Validators.required],

  });
  fromPage: any;
  fromDialog: string;
  action: any;
  itemData: any;
  constructor(
    private fb: FormBuilder,
    private residentialService: ResidentialService, // public dialogRef: MatDialogRef<EnergyProvidersModalComponent>, // @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<PrePaidModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.fromPage = data.pageValue;
    this.action = data.action;
    this.itemData = data.itemData;
  }

  ngOnInit() {
    console.log('parent', this.fromPage);
    if (this.action == 'Update') {
      const postobj = this.setModulesInfo();
      this.prePaidForm.patchValue({
        // {ModuleID: "1", ModuleName: "ACH Credit FY"}
        providerName: this.itemData['ProviderName'],
        energyRate: this.itemData['EnergyRate'],
        utilityName: this.itemData['UtilityName'],
        tDSPRatePerMonth: this.itemData['TDSPRatePerMonth'],
        TDSPRatePerkWh: this.itemData['TDSPRatePerkWh'],
        FivehundredkWh: this.itemData['FiveHundredkWh'],
        ThousandkWh: this.itemData['ThousandkWh'],
        TwoThousandkWh: this.itemData['TwoThousandkWh'],
        tDU_Charges_Month: this.itemData['TDU_Charges_Month'],
        tDU_Charges_Kwh: this.itemData['TDU_Charges_Kwh'],
        link: this.itemData['EFL'],
      });
    }
  }
  setModulesInfo() {
    let providerName = this.prePaidForm.get('providerName').value;
    let energyRate = this.prePaidForm.get('energyRate').value;
    let utilityName = this.prePaidForm.get('utilityName').value;
    let tDSPRatePerMonth = this.prePaidForm.get('tDSPRatePerMonth').value;
    let TDSPRatePerkWh = this.prePaidForm.get('TDSPRatePerkWh').value;
    let FivehundredkWh = this.prePaidForm.get('FivehundredkWh').value;
    let ThousandkWh = this.prePaidForm.get('ThousandkWh').value;
    let TwoThousandkWh = this.prePaidForm.get('TwoThousandkWh').value;
    let tDU_Charges_Month = this.prePaidForm.get('tDU_Charges_Month').value;
    let tDU_Charges_Kwh = this.prePaidForm.get('tDU_Charges_Kwh').value;
    let link = this.prePaidForm.get('link').value;

    let postobj = {
      ProviderName: providerName,
      EnergyRate: energyRate,
      UtilityName: utilityName,
      TDSPRatePerMonth: tDSPRatePerMonth,
      TDSPRatePerkWh: TDSPRatePerkWh,
      FiveHundredkWh: FivehundredkWh,
      ThousandkWh: ThousandkWh,
      TwoThousandkWh: TwoThousandkWh,
      TDU_Charges_Month: tDU_Charges_Month,
      TDU_Charges_Kwh: tDU_Charges_Kwh,
      EFL:link
    };
    return postobj;
  }
  postDataOfNewEnergyProvider() {
    const postobj = this.setModulesInfo();
    if (this.action == 'Update') {
      this.updateProvider(postobj);
    } else {
      this.createProvider(postobj);
    }
  }
  updateProvider(postobj) {
    let rowIndex = this.fromPage.findIndex(
      (element) =>
        element['ProviderName'] == this.itemData['ProviderName'] &&
        element['UtilityName'] == this.itemData['UtilityName']
    );
    this.residentialService
      .postPrepaidProvidersInfo(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        if (rowIndex) {
          this.fromPage[rowIndex] = JSON.parse(JSON.stringify(postobj));
        }
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  createProvider(postobj) {
    this.residentialService
      .postPrepaidProvidersInfo(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
